export default __webpack_public_path__ + "img/3f0409fac32160813e20ec8fbd47febd.svg";